//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex'
import { questionOwnerType } from '@/server/constants'
import confirmActiveProjectQuestionChange from '@/components/questions/confirmActiveProjectQuestionChange'

const UNCATEGORIZED = 'Uncategorized'

const emptyForm = () => ({
  primaryCategory: '',
  secondaryCategory: '',
  phase: null,
  required: null
})

// LSO-525: bulk-edit the category, phase and required flag of the selected
// questions (template or project). Blank fields are left unchanged.
export default {
  name: 'UpdateQuestionsModal',
  props: {
    source: {
      type: Object,
      default: null
    },
    sourceType: {
      type: String,
      required: true,
      validator: value => ['template', 'project'].includes(value)
    }
  },
  data() {
    return {
      form: emptyForm(),
      primaryOptions: [],
      secondaryOptions: [],
      secondariesFor: null,
      listOpen: false,
      collapsed: {},
      saving: false
    }
  },
  computed: {
    ...mapGetters({
      questionsSelected: 'questions/getQuestionsSelected'
    }),
    ownerType() {
      return this.sourceType === 'template' ? questionOwnerType.template : questionOwnerType.project
    },
    phaseCount() {
      return this.source?.phaseCount || 1
    },
    primaryText() {
      return (this.form.primaryCategory || '').trim()
    },
    secondaryText() {
      return (this.form.secondaryCategory || '').trim()
    },
    filteredPrimary() {
      return this.filterOptions(this.primaryOptions, this.primaryText)
    },
    filteredSecondary() {
      return this.filterOptions(this.secondaryOptions, this.secondaryText)
    },
    // the one primary all selected questions share, or '' when they differ
    sharedPrimary() {
      const primaries = new Set(this.questionsSelected.map(q => q.primaryCategory || ''))
      return primaries.size === 1 ? [...primaries][0] : ''
    },
    // selected questions as a primary → secondary tree, in selection order;
    // questions without a secondary sit directly under their primary
    selectedGroups() {
      const primaries = new Map()
      this.questionsSelected.forEach((question) => {
        const primaryName = question.primaryCategory || UNCATEGORIZED
        if (!primaries.has(primaryName)) {
          primaries.set(primaryName, { key: primaryName, name: primaryName, count: 0, secondaries: new Map() })
        }
        const primary = primaries.get(primaryName)
        const secondaryName = question.secondaryCategory || ''
        if (!primary.secondaries.has(secondaryName)) {
          primary.secondaries.set(secondaryName, {
            key: `${primaryName} › ${secondaryName}`,
            name: secondaryName,
            questions: []
          })
        }
        primary.secondaries.get(secondaryName).questions.push(question)
        primary.count++
      })
      return [...primaries.values()].map(primary => ({
        ...primary,
        secondaries: [...primary.secondaries.values()]
      }))
    },
    hasChanges() {
      return Boolean(this.primaryText || this.secondaryText) ||
        this.form.phase !== null ||
        this.form.required !== null
    },
    primaryInvalid() {
      return this.primaryText === UNCATEGORIZED
    },
    secondaryInvalid() {
      return this.secondaryText === UNCATEGORIZED
    },
    invalid() {
      return this.primaryInvalid || this.secondaryInvalid
    },
    secondaryMessage() {
      if (this.secondaryInvalid) {
        return 'Invalid category name!'
      }
      if (this.secondaryText && !this.primaryText) {
        return 'Applies only to selected questions that already have a primary category'
      }
      return ''
    }
  },
  methods: {
    ...mapActions({
      bulkUpdateQuestions: 'questions/bulkUpdateQuestions',
      fetchAllPrimaryCategoriesForSort: 'questions/fetchAllPrimaryCategoriesForSort',
      fetchAllSecondaryCategoriesForSort: 'questions/fetchAllSecondaryCategoriesForSort',
      setQuestionsSelect: 'questions/setQuestionsSelect'
    }),
    isCollapsed(key) {
      return Boolean(this.collapsed[key])
    },
    toggle(key) {
      this.$set(this.collapsed, key, !this.collapsed[key])
    },
    filterOptions(options, text) {
      const needle = text.toLowerCase()
      return options.filter(o => o !== UNCATEGORIZED && o.toLowerCase().includes(needle))
    },
    async show() {
      if (!this.source?._id) {
        return
      }
      this.form = emptyForm()
      this.listOpen = false
      // with several primaries, start each one collapsed to keep the list short
      this.collapsed = {}
      if (this.selectedGroups.length > 1) {
        this.selectedGroups.forEach((primary) => {
          this.$set(this.collapsed, primary.key, true)
        })
      }
      this.secondaryOptions = []
      this.secondariesFor = null
      const primaries = await this.fetchAllPrimaryCategoriesForSort({
        owner: this.source._id,
        type: this.ownerType
      })
      this.primaryOptions = Array.isArray(primaries) ? primaries : []
      this.form.primaryCategory = this.sharedPrimary
      this.$bvModal.show('update-questions-modal')
      await this.loadSecondaries()
    },
    hide() {
      this.$bvModal.hide('update-questions-modal')
    },
    onPrimaryChanged() {
      // defer so v-model has the final value after select/blur
      this.$nextTick(() => this.loadSecondaries())
    },
    async loadSecondaries() {
      // with no primary, list every secondary of the template/project
      const primary = this.primaryText
      if (primary === this.secondariesFor) {
        return
      }
      this.secondariesFor = primary
      const secondaries = await this.fetchAllSecondaryCategoriesForSort({
        owner: this.source._id,
        type: this.ownerType,
        primary
      })
      this.secondaryOptions = Array.isArray(secondaries) ? secondaries : []
    },
    buildUpdates() {
      const updates = {}
      if (this.primaryText) {
        updates.primaryCategory = this.primaryText
      }
      if (this.secondaryText) {
        updates.secondaryCategory = this.secondaryText
      }
      if (this.form.phase !== null) {
        updates.phase = this.form.phase
      }
      if (this.form.required !== null) {
        updates.required = this.form.required
      }
      return updates
    },
    async submit() {
      if (!this.hasChanges || this.invalid || this.saving) {
        return
      }
      const total = this.questionsSelected.length
      const questionIds = this.questionsSelected.map(q => q._id)
      const updates = this.buildUpdates()
      // on an active project, phase and required changes reach participants
      // silently, so ask the owner first
      if (this.sourceType === 'project') {
        const confirmed = await confirmActiveProjectQuestionChange(this, this.source, {
          required: 'required' in updates,
          phase: 'phase' in updates,
          count: total
        })
        if (!confirmed) {
          return
        }
      }
      this.saving = true
      try {
        const res = await this.bulkUpdateQuestions({ questionIds, updates })
        let message = `Updated ${res.matched} of ${total} question${total !== 1 ? 's' : ''}.`
        if (res.skippedRequired > 0) {
          message += ` ${res.skippedRequired} requirement question${res.skippedRequired !== 1 ? 's were' : ' was'} left unchanged.`
        }
        this.toast(message, 'Update Successful', 'success')
        this.hide()
        this.setQuestionsSelect({ project: {}, property: {}, status: false, questions: [] })
        this.$emit('updated')
      } catch (error) {
        const message = error.response?.data?.message || error.message || 'Failed to update questions'
        this.toast(message, 'Update Failed', 'danger')
      } finally {
        this.saving = false
      }
    },
    toast(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
        autoHideDelay: 5000,
        solid: true,
        toaster: 'b-toaster-top-right'
      })
    }
  }
}
